// lineConfigUtil.ts
export const LINE_ARGS = [
  "LINE_LIFF_TAIWAN",
  "LINE_LIFF_SR",
  "LINE_LIFF_ADCOINZ",
  "LINE_SSO",
] as const;

export type LineArg = (typeof LINE_ARGS)[number];
type LineConfigKey = "liffId" | "botId" | "channelId";
type LineConfig = Record<LineConfigKey, string | undefined>;

const removeLeadingAt = (value?: string) => value?.replace(/^@/, "");

/**
 * Central LINE configuration
 */
const CONFIG: Record<LineArg, LineConfig> = {
  LINE_LIFF_TAIWAN: {
    liffId: process.env.REACT_APP_LINE_LIFF_TAIWAN,
    botId: removeLeadingAt(process.env.REACT_APP_LINE_BOT_BASIC_ID_LINE_TW),
    channelId: process.env.REACT_APP_PUBLIC_LINE_LOGIN_CHANNEL_ID_TW || ""
  },
  LINE_LIFF_SR: {
    liffId: process.env.REACT_APP_LINE_LIFF_SR,
    botId: removeLeadingAt(process.env.REACT_APP_LINE_BOT_BASIC_ID),
    channelId: process.env.REACT_APP_PUBLIC_LINE_LOGIN_CHANNEL_ID
  },
  LINE_LIFF_ADCOINZ: {
    liffId: process.env.REACT_APP_LINE_LIFF_ADCOINZ,
    botId: removeLeadingAt(process.env.REACT_APP_LINE_BOT_BASIC_ID_ADCOINZ),
    channelId: process.env.REACT_APP_PUBLIC_LINE_LOGIN_CHANNEL_ID_ADCOINZ
  },
  LINE_SSO: {
    liffId: undefined,
    botId: undefined,
    channelId: process.env.REACT_APP_PUBLIC_LINE_LOGIN_CHANNEL_ID
  },
};


export function parseLineArg(value: string | null | undefined): LineArg {
  if (!value || !LINE_ARGS.includes(value as LineArg)) {
    throw new Error(`Invalid login_method: ${value ?? "(missing)"}`);
  }
  return value as LineArg;
}

function getRequiredConfig(arg: LineArg, key: LineConfigKey): string {
  const value = CONFIG[arg][key]?.trim();

  if (!value) {
    throw new Error(`Missing ${key} for ${arg}`);
  }

  return value;
}

export const getLiffId = (arg: LineArg) => getRequiredConfig(arg, "liffId");
export const getBotId = (arg: LineArg) => getRequiredConfig(arg, "botId");
export const getChannelId = (arg: LineArg) =>
  getRequiredConfig(arg, "channelId");
